import { render, staticRenderFns } from "./ICard.vue?vue&type=template&id=41700c60&functional=true&"
import script from "./ICard.vue?vue&type=script&lang=js&"
export * from "./ICard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports